import type { Chat } from "../api/api";

// Title of an Algemeen chat as Waves users (admin/kam) see it: Algemeen
// chats are one-on-one, so it's named after the partner user, or marked as
// archived once it has none any more.
export function algemeenChatLabel(chat: Chat): string {
  if (chat.archived) return "Algemeen (archief)";
  return chat.user_name ?? "Algemeen";
}
